import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import AnonymityNotice from "@/components/AnonymityNotice";

export default function RfqMessageThread({ rfqId, userRole }) {
  const [msgs, setMsgs] = useState([]);
  const [text, setText] = useState("");
  const load = () => api.get(`/rfqs/${rfqId}/messages`).then(r => setMsgs(r.data)).catch(() => setMsgs([]));
  useEffect(() => { load(); const t = setInterval(load, 15000); return () => clearInterval(t); }, [rfqId]);
  const send = async () => { if (!text.trim()) return; await api.post(`/rfqs/${rfqId}/messages`, { message: text }); setText(""); load(); };
  if (userRole === "supplier") return null;
  return (
    <div className="card" style={{ padding: 20, marginTop: 24 }}>
      <div className="font-mono" style={{ fontSize: 11, letterSpacing: ".1em", color: "var(--ink-mute)", marginBottom: 12 }}>RFQ MESSAGING · BUYER ↔ ADMIN</div>
      <AnonymityNotice context="message" />
      <div style={{ maxHeight: 260, overflowY: "auto", display: "flex", flexDirection: "column", gap: 10, marginBottom: 12 }}>
        {msgs.length === 0 && <div style={{ color: "var(--ink-mute)", fontSize: 13 }}>No messages yet.</div>}
        {msgs.map(m => (
          <div key={m.id} style={{ background: m.role === "admin" ? "var(--navy-700)" : "var(--navy-900)", border: "1px solid var(--line)", borderLeft: `3px solid ${m.role === "admin" ? "#60a5fa" : "var(--amber-500)"}`, padding: 10, borderRadius: 4 }}>
            <div className="font-mono" style={{ fontSize: 10, color: "var(--ink-mute)", textTransform: "uppercase", letterSpacing: ".1em", marginBottom: 4 }}>{m.role} · {new Date(m.at).toLocaleString()}</div>
            <div style={{ fontSize: 13, whiteSpace: "pre-wrap" }}>{m.message}</div>
          </div>
        ))}
      </div>
      <div style={{ display: "flex", gap: 8 }}>
        <input className="input" value={text} onChange={e => setText(e.target.value)} onKeyDown={e => e.key === "Enter" && send()} placeholder="Write a message to admin…" data-testid="rfq-msg-input" />
        <button className="btn btn-primary" onClick={send} data-testid="rfq-msg-send">Send</button>
      </div>
    </div>
  );
}
